export const GLOBAL_ROLES = ['admin', 'superuser'];
export const FARM_LEAD_ROLES = ['farm_owner', 'farm_manager'];
export const WORKER_ROLE = 'worker';

export function normalizeRole(role) {
  const raw = String(role || '').trim().toLowerCase();
  if (!raw) return WORKER_ROLE;
  if (raw === 'user') return WORKER_ROLE;
  if (raw === 'rd') return 'admin';
  return raw;
}

export function isGlobalRole(role) {
  return GLOBAL_ROLES.includes(normalizeRole(role));
}

export function isFarmLeadRole(role) {
  return FARM_LEAD_ROLES.includes(normalizeRole(role));
}

export function isWorkerRole(role) {
  return normalizeRole(role) === WORKER_ROLE;
}

export function isFarmOwnerRole(role) {
  return normalizeRole(role) === 'farm_owner';
}

export function canRestartControllerForDevice(user, device) {
  const role = normalizeRole(user?.role);
  if (isGlobalRole(role)) return true;
  if (!isFarmOwnerRole(role)) return false;
  const userFarmId = user?.farmId;
  const deviceFarmId = device?.farmId;
  return Boolean(userFarmId && deviceFarmId && String(userFarmId) === String(deviceFarmId));
}
